import { FC } from 'react';

import styles from '../PrivacyPolicyArticle/style.module.scss'

interface IProps {
  title: string;
}

const PrivacyPolicyArticle: FC<IProps> = ({ title }) => {
  return (
    <div className={`${styles.modal} `}>
      <h1>{title}</h1>
      <h2>ZIGNET INSTITUIÇÃO DE PAGAMENTO LTDA.</h2>
      <div>
        <p>
          A ZIGNET INSTITUIÇÃO DE PAGAMENTO LTDA. (“ZIGNET”) oferece serviços de
          facilitações de pagamentos, possibilitando a negociação e o pagamento
          de débitos em atraso relativos à veículos junto ao Órgão Público
          competente ou de boletos em geral, por meio de cartão de débito ou de
          crédito, inclusive de forma parcelada, em ambiente online ou físico
          (“Serviços”).
        </p>
      </div>
      <div>
        <h3>1. Informações gerais</h3>
        <p>
          A presente Política de Privacidade contém informações a respeito do
          modo como a ZIGNET realiza o tratamento de Dados Pessoais dos Usuários
          que acessam o website ou utilizam os Serviços. Seu objetivo é
          esclarecer aos interessados os tipos de dados que são coletados, os
          motivos da coleta e a forma como o usuário poderá atualizar, gerenciar
          ou excluir estas informações.
        </p>
      </div>
      <div>
        <h3>2. Legislação Aplicável</h3>
        <p>
          Esta Política de Privacidade foi elaborada em conformidade com a Lei
          Federal n. 12.965 de 23 de abril de 2014 (Marco Civil da Internet),
          com a Lei Federal n. 13.709, de 14 de agosto de 2018 (Lei de Proteção
          de Dados Pessoais) e com o Regulamento UE n. 2016/679 de 27 de abril
          de 2016 (Regulamento Geral Europeu de Proteção de Dados Pessoais -
          RGDP).
        </p>
      </div>
      <div>
        <h3>3. Conceitos</h3>
        <p>
          Antes da iniciar a leitura da Política de Privacidade, seguem alguns
          conceitos que auxiliarão o Usuário na melhor compreensão do
          instrumento. Os termos poderão ser utilizados no singular ou no plural
          e terão o mesmo significado.
        </p>
        <p>
          <strong>Dado Pessoal. </strong>Toda e qualquer informação relacionada
          ao Titular disponibilizada pelo <strong>Usuário </strong>durante a
          utilização do website ou dos Serviços.
        </p>
        <p>
          <strong>Encarregado. </strong>Pessoa estabelecida pela ZIGNET que será
          responsável por realizar a comunicação entre o Titular dos Dados
          Pessoais, a ZIGNET e a Autoridade Nacional de Proteção de Dados.
        </p>
        <p>
          <strong>Política de Privacidade. </strong>Instrumento que estabelece
          as formas de tratamento de Dados Pessoais dos Titulares.
        </p>
        <p>
          <strong>Serviços. </strong>Os serviços disponibilizados pela ZIGNET no
          website ou de forma presencial e regidos pelos Termos de Uso do
          website acessível por meio do{' '}
          <strong>
            <a
              className={styles.linkSiteBlack}
              href="https://www.zignet.com.br"
              target="_blank"
              rel="noreferrer"
            >
              www.ZIGNET.com.br
            </a>
          </strong>
          , quando aplicável, e pela legislação em vigor.
        </p>
        <p>
          <strong>Titular. </strong>Pessoa natural, identificada ou
          identificável, a quem se refere o Dado Pessoal tratado pela ZIGNET.
        </p>
        <p>
          <strong>Tratamento. </strong>Toda e qualquer forma de utilização do
          Dado Pessoal do Titular, inclusive, sem limitação, a coleta, produção,
          recepção, classificação, utilização, acesso, reprodução, transmissão,
          distribuição, processamento, arquivamento, armazenamento, eliminação,
          avaliação ou controle da informação, modificação, comunicação,
          transferência, difusão ou extração.
        </p>
        <p>
          <strong>Usuário. </strong>Titular dos Dados Pessoais que utilizar os
          Serviços da ZIGNET, por website ou presencial.
        </p>
      </div>
      <div>
        <h3>Onde ficam armazenados os dados pessoais?</h3>
        <p>
          Todos os dados pessoais envolvidos na transação são processados e
          armazenado em servidores exclusivos da ZIGNET, já os dados dos cartões
          de credito não são registrados, somente usados no momento da
          finalização da transação, com exceção dos quatro últimos dígitos do
          cartão e o número da operação de credito.
        </p>
      </div>
      <div>
        <h3>4. Aplicação da Política de Privacidade</h3>
        <p>
          <strong>Público-alvo. </strong>A presente Política de Privacidade se
          aplica ao Usuário dos Serviços da ZIGNET, na qualidade de Titular dos
          Dados Pessoais tratados, bem como a todos aqueles que tenham seus
          dados pessoais tratados pela ZIGNET, exceto se houver política de
          privacidade específica nesse sentido.
        </p>
        <p>
          <strong>Autorização de Terceiros. </strong>Caso o Usuário dos Serviços
          da ZIGNET realize pagamento de débitos em nome de terceiros, o Usuário
          deverá se certificar de que possui todas as autorizações para
          utilização e compartilhamento dos Dados Pessoais do Titular, sob pena
          de ser considerado exclusivamente responsável pelos danos a que der
          causa.
        </p>
      </div>
      <div>
        <h3>5. Tratamento de Dados Pessoais do Titular</h3>
        <p>
          <strong>Princípios. </strong>A ZIGNET cumpre todos os princípios
          legais para tratamento de dados pessoais do Titular exigidos pela
          legislação aplicável. Assim, a ZIGNET trata os Dados Pessoais do
          Titular para propósitos legítimos, nos limites informados ao Titular
          por meio da presente Política de Privacidade, por meio de medidas
          técnicas e organizacionais adequadas e que visam evitar incidentes de
          segurança, cujos procedimentos poderão ser consultados pelo Titular e
          órgão regulamentador a qualquer momento, garantindo ao Titular
          consulta facilitada, transparência e possibilidade de atualização dos
          Dados Pessoais sempre que necessário.
        </p>
        <p>
          <strong>Essencialidade e Consentimento. </strong>Todos os Dados
          Pessoais solicitados pela ZIGNET são essenciais para a utilização da
          Plataforma e para a prestação dos Serviços contratados pelo Usuário.
          Caso o Usuário opte por não fornecer qualquer um dos Dados Pessoais
          solicitados, não será possível utilizar os Serviços. Quando a
          divulgação de Dados Pessoais for opcional, o Usuário poderá não os
          fornecer, sem prejuízo aos Serviços, de modo que, ao fornecer os Dados
          Pessoais opcionais, consentirá automaticamente com seu tratamento na
          forma estabelecida. Os dados pessoais que forem tratados com base
          legal de consentimento poderão ser deletados a qualquer momento,
          mediante solicitação do Titular, sem prejuízo aos Serviços
          contratados.
        </p>
        <p>
          <strong>Bases Legais. </strong>A legislação autoriza a ZIGNET a tratar
          os Dados Pessoais do Titular em determinadas hipóteses, as quais serão
          aplicadas a depender da finalidade de seu tratamento. Nem sempre o
          tratamento dos Dados Pessoais dependerá do consentimento do Usuário,
          conforme mencionado anteriormente.
        </p>
        <p>
          <strong>Formas de Tratamento de Dados Pessoais pela ZIGNET. </strong>A
          ZIGNET realizará o Tratamento dos Dados Pessoais do Titular de acordo
          com o estabelecido a seguir.
        </p>
        <table>
          <tbody>
            <tr>
              <td>Tipo de Dado Pessoal e Finalidade</td>
              <td>Base Legal</td>
            </tr>
            <tr>
              <td>
                <p>
                  Dados de Cadastro: Nome completo, RG, CPF, Renavam e dados
                  bancários.{' '}
                </p>
                <p>
                  Finalidade: Realização de Cadastro no Website da ZIGNET para
                  utilização dos Serviços.
                </p>
              </td>
              <td>
                <p>
                  Execução de contrato ou de procedimentos preliminares. Inciso
                  V, do artigo 7º, da Lei nº 13.709 de 14 de agosto de 2018 –
                  Lei Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  Dados de Débitos Veiculares: Placa do veículo, CPF do titular,
                  Renavam e débitos pendentes de pagamento.
                </p>
                <p>
                  Finalidade: Procedimentos para viabilizar serviços de
                  consulta, pagamento e parcelamento de débitos veiculares por
                  website ou presencial.
                </p>
              </td>
              <td>
                <p>
                  Execução de contrato ou de procedimentos preliminares. Inciso
                  V, do artigo 7º, da Lei nº 13.709 de 14 de agosto de 2018 –
                  Lei Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Dados de Boletos: Número do boleto.</p>
                <p>
                  Finalidade: Procedimentos para viabilizar serviços de
                  consulta, pagamento e parcelamento de débitos veiculares.
                </p>
              </td>
              <td>
                <p>
                  Execução de contrato ou de procedimentos preliminares. Inciso
                  V, do artigo 7º, da Lei nº 13.709 de 14 de agosto de 2018 –
                  Lei Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Dados de Comunicação: Celular e e-mail.</p>
                <p>
                  Finalidade: Envio de comunicações a respeito dos serviços
                  contratados.
                </p>
              </td>
              <td>
                <p>
                  Execução de contrato ou de procedimentos preliminares. Inciso
                  V, do artigo 7º, da Lei nº 13.709 de 14 de agosto de 2018 –
                  Lei Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  Dados de Pagamento: Nome, CPF, número do cartão de crédito,
                  validade do cartão de crédito, código de segurança e endereço
                  de cobrança.
                </p>
                <p>
                  Finalidade: Viabilização do pagamento dos serviços
                  contratados.
                </p>
              </td>
              <td>
                <p>
                  Execução de contrato ou de procedimentos preliminares. Inciso
                  V, do artigo 7º, da Lei nº 13.709 de 14 de agosto de 2018 –
                  Lei Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Dados de Segurança: Nome e celular.</p>
                <p>
                  Finalidade: Envio de SMS para autenticação de duplo fator como
                  forma de garantir a segurança e legitimidade do cadastro e
                  contratação dos serviços.
                </p>
              </td>
              <td>
                <p>
                  Cumprimento de obrigação legal ou regulatória. Inciso II, do
                  artigo 7º, da Lei nº 13.709 de 14 de agosto de 2018 – Lei
                  Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Dados Públicos: diversos.</p>
                <p>
                  Finalidade: Viabilizar a prestação dos serviços por meio da
                  consulta e utilização de dados pessoais constantes em base de
                  dados públicas.
                </p>
              </td>
              <td>
                <p>
                  Execução de contrato ou de procedimentos preliminares. Inciso
                  V, do artigo 7º, da Lei nº 13.709 de 14 de agosto de 2018 –
                  Lei Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Dados de Marketing: nome e e-mail.</p>
                <p>
                  Finalidade: Envio de informações institucionais e promocionais
                  da ZIGNET.
                </p>
              </td>
              <td>
                <p>
                  Consentimento. Inciso I, do artigo 7º, da Lei nº 13.709 de 14
                  de agosto de 2018 – Lei Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  Dados Antifraude: Nome, CPF, e-mail, Telefone, endereço, Placa
                  e Renavam.
                </p>
                <p>Finalidade: Prevenção a fraudes.</p>
              </td>
              <td>
                <p>
                  Proteção ao Crédito. Inciso X, do artigo 7º, da Lei nº 13.709
                  de 14 de agosto de 2018 – Lei Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  Dados de Atendimento: Nome, CPF, e-mail, telefone, placa,
                  Renavam e número de protocolo.
                </p>
                <p>
                  Finalidade: Atendimento do Usuário para localizar o número do
                  pedido e disponibilizar informações sobre os serviços
                  contratados.
                </p>
              </td>
              <td>
                <p>
                  Cumprimento de Obrigação Legal ou Regulatória. Inciso II, do
                  artigo 7º, da Lei nº 13.709 de 14 de agosto de 2018 – Lei
                  Geral de Proteção de Dados.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          <strong>Finalidades. </strong>Os dados pessoais dos Titulares não
          serão utilizados pela ZIGNET para finalidades diversas das
          estabelecidas acima. A ZIGNET não aluga, vende ou transfere os dados
          pessoais dos Titulares de forma onerosa ou para finalidade diversa da
          estabelecida no presente instrumento.
        </p>
        <p>
          <strong>Compartilhamento dos Dados Pessoais. </strong>Para a prestação
          dos Serviços, a ZIGNET deverá compartilhar os Dados Pessoais dos
          Titulares com instituições financeiras, instituições de meio de
          pagamento, órgãos públicos e terceiros para garantir a execução dos
          Serviços, a proteção ao crédito e cumprimento de obrigação legal ou
          regulatória. A ZIGNET deverá, ainda, compartilhar alguns dos Dados
          Pessoais do Titular com terceiros para viabilizar a obtenção de dados
          e informações adicionais a respeito do Titular, por meio de cruzamento
          de dados e informações constantes em base de dados públicas e
          privadas, cuja obtenção é essencial para a prestação dos Serviços e
          com o provedor de armazenamento em nuvem. O compartilhamento dos Dados
          Pessoais com terceiros será realizado nos termos e limites
          estabelecidos pela Lei Geral de Proteção de Dados e todos os terceiros
          estarão vinculados ao cumprimento de medidas não menos restritivas do
          que as estabelecidas no presente instrumento. O compartilhamento dos
          Dados Pessoais se dará exclusivamente na medida do necessário para
          execução dos Serviços e não será realizado de forma permanente.
        </p>
        <p>
          <strong>Retenção. </strong>Os Dados Pessoais do Titular serão mantidos
          pela ZIGNET somente pelo tempo que for necessário para cumprir com as
          finalidades para as quais foram coletados ou se houver necessidade de
          cumprimento de obrigação legal ou regulatória ou de garantia de
          direitos em processos judiciais, administrativos e de arbitragem. Por
          segurança, cada categoria de dados possui um prazo específico de
          retenção, o qual não será superior a 10 anos, após o encerramento da
          finalidade para o qual foi coletado, exceto se a Lei Geral de Proteção
          de Dados permitir a retenção por prazo superior.
        </p>
        <p>
          <strong>Armazenamento. </strong>Os Dados Pessoais coletados pela
          ZIGNET ficam armazenados em servidores em nuvem de terceiros,
          localizados no Brasil ou no exterior. A forma de armazenamento e o
          local poderão ser modificados pela ZIGNET, a seu exclusivo critério,
          observados os requisitos de segurança estabelecidos pela legislação.
        </p>
      </div>
      <div>
        <h3>6. Requisitos de Segurança</h3>
        <p>
          A ZIGNET se esforça para proteger a privacidade da conta e dos Dados
          Pessoais dos Titulares.
        </p>
        <p>
          <strong>Medidas de Segurança Técnicas. </strong>A ZIGNET conta com
          medidas de segurança técnicas de acordo com os padrões exigidos pela
          legislação aplicável e utilizados no mercado, inclusive, mas sem
          limitação, a utilização de criptografia dos Dados Pessoais. A ZIGNET
          está em constante desenvolvimento e realiza auditorias e modificações
          em suas medidas de segurança técnicas de forma periódica.
        </p>
        <p>
          <strong>Medidas de Segurança Organizacionais. </strong>A ZIGNET
          implementa medidas de segurança organizacionais de acordo com os
          padrões exigidos pela legislação e utilizados no mercado, inclusive,
          mas se limitação, a aplicação de políticas internas e treinamento de
          seus colaboradores, bem como procedimentos de resposta a incidentes de
          segurança para mitigar riscos e danos.
        </p>
        <p>
          <strong>Responsabilidade da ZIGNET e do Usuário. </strong>Mesmo que a
          ZIGNET implemente todos os esforços necessários para evitar incidentes
          de segurança, pela natureza tecnológica dos Serviços, incidentes de
          segurança poderão eventualmente ocorrer. A ZIGNET possui procedimentos
          e medidas técnicas para resposta a incidentes de segurança, como forma
          de mitigar riscos e danos. Ainda, importante que o Usuário esteja
          ciente de que acesso ou uso não autorizado de conta, falha de hardware
          ou software e outros fatores podem também comprometer a segurança dos
          Dados Pessoais e, por isso, o Usuário deve também adotar medidas de
          segurança. Além de adotar boas práticas de segurança em relação a sua
          conta e aos Dados Pessoais compartilhados, caso o Usuário identifique
          ou tome conhecimento de algo que comprometa a segurança das
          informações, o Usuário pode entrar em contato com a ZIGNET por meio
          dos canais de comunicação estabelecidos neste instrumento.
        </p>
      </div>
      <div>
        <h3>7. Direitos dos Titulares</h3>
        <p>
          <strong>Exercício de Direitos. </strong>A Lei Geral de Proteção de
          Dados estabelece direitos aos Titulares no que se refere ao Tratamento
          de seus Dados Pessoais. A ZIGNET implementa medidas aptas a garantir
          que todos os direitos garantidos aos Titulares sejam cumpridos.
        </p>
        <p>
          <strong>Direitos dos Titulares. </strong>Aos Titulares são garantidos
          os seguintes direitos: i) Direito de acesso; ii) Direito de
          retificação; iii) Direito de exclusão; iv) Direito de confirmação
          sobre a existência de tratamento; v) Direito de solicitar o bloqueio
          ou eliminação; vi) Direito à informação das entidades públicas ou
          privadas; vi) Direito de restringir o processamento; vii) Direito à
          revisão de decisão automatizada; viii) Direito de oposição a um
          tratamento; ix) Direito à explicação da lógica por trás da coleta dos
          seus dados; x) Direito à informação sobre a possibilidade de não
          fornecer consentimento e sobre as consequências da negativa; xi)
          Direito de retirar o seu consentimento.
        </p>
        <p>
          <strong>Formas de Exercício dos Direitos. </strong>Para exercícios dos
          direitos, o Titular poderá entrar em contato com o Encarregado da
          ZIGNET por meio dos canais de comunicação estabelecidos neste
          instrumento. Para requerimentos que ensejem acesso a Dados Pessoais
          exatos, a ZIGNET se reserva o direito de solicitar ao Titular a
          confirmação de informações específicas, como medida de segurança para
          autenticar a identidade do Titular e a propriedade dos Dados Pessoais
          a que se refere o requerimento, para garantir que os Dados Pessoais
          não serão acessados por terceiros ou compartilhados indevidamente.
        </p>
      </div>
      <div>
        <h3>8. Encarregado e Canais de Comunicação</h3>
        <p>
          <strong>Canais de Comunicação. </strong>O Encarregado da ZIGNET poderá
          ser contatado pelos Titulares e demais interessados na privacidade de
          Dados Pessoais tratados pela ZIGNET para prestação dos Serviços por
          meio de{' '}
          <a href="mailto:atendimento@zignet.com.br?subject=Atendimento ZIGNET">
            atendimento@zignet.com.br
          </a>{' '}
          <strong>– (11) 5171.8484.</strong>
        </p>
        <p>
          <strong>Prazo de Atendimento. </strong>O tempo de resposta do
          Encarregado da ZIGNET poderá variar de acordo com a solicitação
          específica realizada e sempre cumprirá o disposto na legislação
          aplicável.
        </p>
        <p>
          <strong>Encarregado do App ZIGNET. </strong>O Encarregado do{' '}
          <strong>App ZIGNET </strong>é a Diretoria de Tecnologia{' '}
          <a href="mailto:ti@zignet.com.br?subject=A Diretoria de Tecnologia">
            ti@zignet.com.br
          </a>
        </p>
      </div>
      <div>
        <h3>9. Alteração da Política de Privacidade</h3>
        <p>
          Ao utilizar os Serviços da ZIGNET, o Usuário automaticamente concorda
          com os termos e condições da presente Política de Privacidade. Caso o
          Usuário não esteja de acordo com as informações estabelecidas neste
          instrumento, o Usuário não deverá utilizar os Serviços da ZIGNET.
        </p>
        <p>
          A presente Política de Privacidade poderá ser atualizada e modificada
          a qualquer momento, a critério exclusivo da ZIGNET. É de
          responsabilidade do Usuário consultar regularmente a atualização deste
          instrumento. A continuidade de utilização dos Serviços da ZIGNET após
          a modificação da Política de Privacidade implicará na aceitação e
          concordância integral do Usuário com as modificações realizadas.
        </p>
      </div>
      <div>
        <h3>10. Disposições Gerais</h3>
        <p>
          <strong>Validade das Disposições. </strong>A nulidade ou invalidade de
          qualquer das cláusulas do presente instrumento não prejudicará a
          validade e eficácia das demais cláusulas e do próprio instrumento.
        </p>
        <p>
          <strong>Novação. </strong>A eventual tolerância de qualquer das partes
          em relação ao cumprimento de qualquer cláusula do presente
          instrumento, ou a abstenção do exercício de qualquer direito, poder,
          recurso ou faculdade assegurados por lei ou por este instrumento não
          configurará novação.
        </p>
        <p>
          <strong>Cessão. </strong>O presente instrumento poderá ser cedido pela
          ZIGNET para quaisquer terceiros, sem necessidade de aprovação prévia
          dos Usuários.
        </p>
      </div>
      <footer>
        <p>Atualizado em 26/04/2023.</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicyArticle;
